import { Component, Inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { AddDiscountCodes, DiscountCode, toRentalDiscountCodePayloads } from '@tokeet-frontend/discount-codes'
import { ConfirmDialogService, SaveForm } from '@tokeet-frontend/tv3-platform'
import { DiscountCodeFormComponent } from '../discount-code-form.component'

@Component({
  selector: 'app-add-discount-code-dialog',
  templateUrl: './add-discount-code-dialog.component.html',
  styleUrls: ['./add-discount-code-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class AddDiscountCodeDialogComponent extends DiscountCodeFormComponent {
  isEdit = false
  rentalIdsCtrl = new FormControl([])

  constructor(
    fb: FormBuilder,
    store: Store<any>,
    confirmDialog: ConfirmDialogService,
    private dialogRef: MatDialogRef<AddDiscountCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { defaults?: Partial<DiscountCode> }
  ) {
    super(fb, store, confirmDialog)
    this.item = {
      ...this.data.defaults,
    }
    this.rentalIdsCtrl.setValue(this.data.defaults?.rental_id ? [this.data.defaults.rental_id] : [])
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup): void {
    const payloads = toRentalDiscountCodePayloads(this.getPayload(form), this.rentalIdsCtrl.value)
    this.store.dispatch(AddDiscountCodes({ payloads }))
    this.close()
  }

  get amountPlaceholder() {
    return this.form.get('type').value === 'pct' ? $localize`Amount` + ' (%)' : $localize`Amount`
  }
}
